import { type ReactNode } from 'react';
import { makeStyles } from 'tss-react/mui';

export type MenuItemActionProps = {
  children: ReactNode;
};

export const MenuItemAction = ({ children }: MenuItemActionProps) => {
  const { classes } = useStyles();

  return (
    <div className={classes.root} data-menu-trailing="action">
      {children}
    </div>
  );
};

MenuItemAction.displayName = 'BaseMenuItem.Action';

const useStyles = makeStyles()(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));
